import {
  ButtonsWrapper,
  ExternalWrapper,
} from '@components/Steps/Steps.styles';
import styled from '@emotion/styled';
import { SmallDesktopBreakpoint } from '@utils/consts/breakpoints.consts';

export const PracticeSectionExternalWrapper = styled(ExternalWrapper)`
  padding: 6.75rem 6.25rem 3.375rem;
  gap: 1rem;

  @media screen and (max-width: ${SmallDesktopBreakpoint}px) {
    padding: 1rem 1rem 0.75rem;
    gap: 1.5rem;
  }
`;

export const PracticeSectionButtonsWrapper = styled(ButtonsWrapper)`
  padding: 1.5rem 8.125rem;
  align-items: center;

  @media screen and (max-width: ${SmallDesktopBreakpoint}px) {
    justify-content: 'center';
    padding: 1rem 1.5rem;
  }
`;

export const MobileFirstImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const MainImageWrapper = styled.div`
  position: relative;
  width: auto;
  height: 14.9375rem;
  margin: -1rem -1rem 0;
`;

export const FirstImage = styled.img`
  width: 100%;
  height: 24rem;
  object-fit: cover;
  border-radius: 1rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
`;

export const FullScreenMobileImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

export const RightImages = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 0.5rem;
`;

export const SelectedImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
  border-radius: 1.25rem;
  z-index: 1;
`;

export const GalleryImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 1.25rem;
`;

export const ViewAllButtonContainer = styled.div`
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  z-index: 2;
  cursor: pointer;
`;

export const ModalMapContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  width: 100%;
  height: ${({ isMobile }) => (isMobile ? '100%' : '55rem')};
  padding-bottom: 1.5rem;
  border-radius: 1.25rem;
`;
